var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg300MlE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    d: "M35 9H1v29l1 2 2 1h28l3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    d: "M36 8.94V2.236A2.237 2.237 0 0 0 33.765 0H2.235A2.237 2.237 0 0 0 0 2.235v34.647a5.595 5.595 0 0 0 5.588 5.588h24.824A5.595 5.595 0 0 0 36 36.882V8.94zm-2.235 27.942a3.357 3.357 0 0 1-3.353 3.353H8.94V32.41a1.118 1.118 0 0 0-2.236 0v7.824H5.588a3.357 3.357 0 0 1-3.353-3.353V2.235h4.47v23.47a1.118 1.118 0 0 0 2.236 0V2.235h24.823v34.647z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg300MlE);
export default __webpack_public_path__ + "static/media/300_ml_e.a8bba74a09198224a9d0963987187010.svg";
export { ForwardRef as ReactComponent };